import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Component, APP_INITIALIZER } from '@angular/core';
//import { Ng1GanttwrapperDirective } from './common/so-gantt/ng1.ganttwrapper.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { ModalModule } from 'ngx-bootstrap';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
//import { SimpleNotificationsModule } from 'angular2-notifications';
import { NoopAnimationsModule, BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { GenService } from './shared/gen-ser.service';
import { DataService } from './shared/dataservice.service';
import { RevisionHandlerService } from './shared/revision-handler.service';
import { DsExportService } from './shared/ds-export.service';
import { ConfigurationService } from './shared/configuration.service';

// import { MatFormFieldModule,MatInputModule, MatGridListModule, MatSelectModule, MatButtonModule, 
//   MatExpansionModule, MatSnackBarModule, MatDividerModule, MatListModule, MatTabsModule, 
//   MatDialogModule, MatCheckboxModule, MatProgressSpinnerModule, MatStepperModule,
//   MatDatepickerModule, MatTableModule,MatSortModule,
//   MatProgressBarModule, MatCardModule, MatChipsModule,
//   MatIconModule, MatButtonToggleModule,
//   DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA, MatRadioModule  } from '@angular/material';

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';

import {MatBottomSheetModule} from '@angular/material/bottom-sheet';

import { MomentDateAdapter, MatMomentDateModule } from '@angular/material-moment-adapter';
//import * as moment from 'moment';


// import { HttpModule } from '@angular/http';
import { SummaryPageComponent } from './summary-page/summary-page.component';
import { RoutingModule } from './routing/routing.module';
import { ProjectsComponent } from './projects/projects.component';

import { MarketingComponent } from './projects/edit-sales-order/marketing/marketing.component';
import { PmCommercialComponent } from './projects/edit-sales-order/pm-commercial/pm-commercial.component';
import { ScmComponent } from './projects/edit-sales-order/scm/scm.component';
import { PlanningComponent } from './projects/edit-sales-order/planning/planning.component';
import { StoreComponent } from './projects/edit-sales-order/store/store.component';
import { LogisticComponent } from './projects/edit-sales-order/logistic/logistic.component';
import { MyTaskComponent } from './my-task/my-task.component';
import { PurchasePoComponent } from './projects/edit-sales-order/purchase-po/purchase-po.component';
import { PurchaseMaterialReceiptComponent } from './projects/edit-sales-order/purchase-material-receipt/purchase-material-receipt.component';
import { ProductionComponent } from './projects/edit-sales-order/production/production.component';
import { QualityComponent } from './projects/edit-sales-order/quality/quality.component';
import { ReportsComponent } from './reports/reports.component';
import { SubSalesorderComponent,AddSuborderPopup } from './projects/edit-sales-order/sub-salesorder/sub-salesorder.component';
import { PmTechnicalSuborderComponent } from './projects/edit-sales-order/pm-technical-suborder/pm-technical-suborder.component';
import { ReviewSaveComponent } from './projects/edit-sales-order/review-save/review-save.component';
import { EditSalesOrderComponent } from './projects/edit-sales-order/edit-sales-order.component';
import { SaveConfirmDialog } from './dialogs/save-confirm-dialog/save-confirm-dialog';
import { LoaderDialog } from './dialogs/loader-dialog/loader-dialog';
import { FileUploadDialog } from './dialogs/file-upload-dialog/file-upload-dialog';
import { SubmitConfirmDialog } from './dialogs/submit-confirm-dialog/submit-confirm-dialog';
import { MaterialFileUploadComponent } from './common/material-file-upload/material-file-upload.component';
import { HttpClientModule } from '@angular/common/http';
import { SOGanttViewerDialog } from './dialogs/so-gantt-viewer-dialog/so-gantt-viewer-dialog';
//import { UpgradeModule } from "@angular/upgrade/static";
import { EnggDrawComponent } from './projects/edit-sales-order/engg-draw/engg-draw.component';
import { EnggProcureComponent } from './projects/edit-sales-order/engg-procure/engg-procure.component';
import { ActualDateDialog } from './dialogs/actual-date-dialog/actual-date-dialog';
import { ValidationDialog } from './dialogs/validation-dialog/validation-dialog';
import { BrowserFailDialog } from './dialogs/browser-fail-dialog/browser-fail-dialog';
import { ActualDateDialog2 } from './dialogs/actual-date-dialog2/actual-date-dialog2';
import { ManfPlanComponent } from './projects/manf-plan/manf-plan.component';
import { MastPlanComponent } from './projects/mast-plan/mast-plan.component';
import { SubSOUIPipePipe } from './filters/sub-souipipe.pipe';
import { SubEqupUIPipePipe} from './filters/sub-equiplevpipe.pipe';
import { DeleteConfirmDialog } from './dialogs/delete-confirm-dialog/delete-confirm-dialog';
import { MaterialSplitNumberComponent } from './common/material-split-number/material-split-number.component';
import { MaterialRevisedDateComponent } from './common/material-revised-date/material-revised-date.component';
import { MyTaskListComponent } from './my-task/my-task-list/my-task-list.component';
import { MyTaskTableComponent } from './my-task/my-task-table/my-task-table.component';
import { saleOrderPipe } from './filters/saleorder.pipe';
import { ClearInputDirective } from './directives/clear-input.directive';
import { ProcessFailDialog } from './dialogs/process-fail-dialog/process-fail-dialog';
import { DownloadsComponent } from './projects/downloads/downloads.component';

import { CookieService } from 'ngx-cookie-service';
import { SerialImportDialog } from './dialogs/serial-import-dialog/serial-import-dialog';
import { MastPlanV2Component } from './projects/mast-plan-v2/mast-plan-v2.component';
import {MastPlanV3Component} from './projects/mast-plan-v3/mast-plan-v3.component'
import {DelMastPlanComponent} from './projects/del-mast-plan/del-mast-plan.component'
import { MaterialColumnFilterComponent } from './common/material-column-filter/material-column-filter.component';
import { ColumnFilterPopComponent } from './common/column-filter-pop/column-filter-pop.component';
import { from } from 'rxjs';
import { DelSubMastPlanComponent } from './projects/del-sub-mast-plan/del-sub-mast-plan.component';
import { ReviewPageComponent } from './review-page/review-page.component';
import { KpisComponent } from './reports/kpis/kpis.component';
// import { HighchartsChartComponent } from 'highcharts-angular';
import {KPIChartService} from './shared/kpi-charts-service';
import { KpisV2Component } from './reports/kpis-v2/kpis-v2.component';
import { KpiExcelComponent } from './reports/kpi-excel/kpi-excel.component';
import { GanttSummaryComponent } from './reports/gantt-summary/gantt-summary.component';
import { KpisV3Component } from './reports/kpis-v3/kpis-v3.component';
import { KpisV4Component } from './reports/kpis-v4/kpis-v4.component';
import { KpisV5Component } from './reports/kpis-v5/kpis-v5.component';
import { MarketingKpiComponent } from './reports/kpis-v3/marketing-kpi/marketing-kpi.component';
import { EnggDrawKpiComponent } from './reports/kpis-v3/engg-draw-kpi/engg-draw-kpi.component';
import { EnggProcureKpiComponent } from './reports/kpis-v3/engg-procure-kpi/engg-procure-kpi.component';
import { PmTechnicalSuborderKpiComponent } from './reports/kpis-v3/pm-technical-suborder-kpi/pm-technical-suborder-kpi.component';
import { ScmKpiComponent } from './reports/kpis-v3/scm-kpi/scm-kpi.component';
import { PlanningKpiComponent } from './reports/kpis-v3/planning-kpi/planning-kpi.component';
import { PurchaseMaterialReceiptKpiComponent } from './reports/kpis-v3/purchase-material-receipt-kpi/purchase-material-receipt-kpi.component';
import { StoreKpiComponent } from './reports/kpis-v3/store-kpi/store-kpi.component';
import { ProductionKpiComponent } from './reports/kpis-v3/production-kpi/production-kpi.component';
import { LogisticKpiComponent } from './reports/kpis-v3/logistic-kpi/logistic-kpi.component';
import { QualityKpiComponent } from './reports/kpis-v3/quality-kpi/quality-kpi.component';
import { LineItemImportDialog } from './dialogs/line-item-import-dialog/line-item-import-dialog';
import { ChangeNoteComponent } from './projects/edit-sales-order/change-note/change-note.component';
import { SerialDataImportDialog } from './dialogs/serial-data-import-dialog/serial-data-import-dialog';
import { DataPreviewDialog } from './dialogs/data-preview-dialog/data-preview-dialog';
import { SAPFetchResultDialog } from './dialogs/sap-fetch-result-dialog/sap-fetch-result-dialog';
import { HighchartsChartModule } from 'highcharts-angular';
import { DataSheetComponent } from './projects/edit-sales-order/data-sheet/data-sheet.component';
import { AddDatasheetPopup } from './projects/edit-sales-order/data-sheet/add-datasheet-popup';
import { DsGeneralComponent } from './projects/edit-sales-order/data-sheet/ds-general/ds-general.component';
import { DsPanelComponent } from './projects/edit-sales-order/data-sheet/ds-panel/ds-panel.component';
import { DataSheetImportDialog } from './dialogs/data-sheet-import-dialog/data-sheet-import-dialog';
import { DsBusbarsComponent } from './projects/edit-sales-order/data-sheet/ds-busbars/ds-busbars.component';
import { DsPaintingComponent } from './projects/edit-sales-order/data-sheet/ds-painting/ds-painting.component';
import { DsControlAuxComponent } from './projects/edit-sales-order/data-sheet/ds-control-aux/ds-control-aux.component';
import { DsControlWiringComponent } from './projects/edit-sales-order/data-sheet/ds-control-wiring/ds-control-wiring.component';
import { DsTerminalBlocksComponent } from './projects/edit-sales-order/data-sheet/ds-terminal-blocks/ds-terminal-blocks.component';
import { DsCircuitBreakerComponent } from './projects/edit-sales-order/data-sheet/ds-circuit-breaker/ds-circuit-breaker.component';
import { DsCurrentTransformerComponent } from './projects/edit-sales-order/data-sheet/ds-current-transformer/ds-current-transformer.component';
import { DsPotentialTransformerComponent } from './projects/edit-sales-order/data-sheet/ds-potential-transformer/ds-potential-transformer.component';
import { DsNumericalRelayComponent } from './projects/edit-sales-order/data-sheet/ds-numerical-relay/ds-numerical-relay.component';
import { DsAuxRelayComponent } from './projects/edit-sales-order/data-sheet/ds-aux-relay/ds-aux-relay.component';
import { DsMetersComponent } from './projects/edit-sales-order/data-sheet/ds-meters/ds-meters.component';
import { DsSurgeArrestorComponent } from './projects/edit-sales-order/data-sheet/ds-surge-arrestor/ds-surge-arrestor.component';
import { DsAnnuciatorComponent } from './projects/edit-sales-order/data-sheet/ds-annuciator/ds-annuciator.component';
import { DsSwitchesComponent } from './projects/edit-sales-order/data-sheet/ds-switches/ds-switches.component';
import { DsEthSwitchesComponent } from './projects/edit-sales-order/data-sheet/ds-eth-switches/ds-eth-switches.component';
import { DsEarthingDevicesComponent } from './projects/edit-sales-order/data-sheet/ds-earthing-devices/ds-earthing-devices.component';
import { DsSpecialDevicesComponent } from './projects/edit-sales-order/data-sheet/ds-special-devices/ds-special-devices.component';
import { DsFoundationFrameComponent } from './projects/edit-sales-order/data-sheet/ds-foundation-frame/ds-foundation-frame.component';
import { DsSwbAccQtyComponent } from './projects/edit-sales-order/data-sheet/ds-swb-acc-qty/ds-swb-acc-qty.component';
import { DsCodesStdsComponent } from './projects/edit-sales-order/data-sheet/ds-codes-stds/ds-codes-stds.component';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { DataSheetSuborderComponent } from './projects/edit-sales-order/data-sheet-suborder/data-sheet-suborder.component';
import { CopyDataSheetSuborderComponent } from './projects/edit-sales-order/data-sheet-suborder/copy-data-sheet-suborder/copy-data-sheet-suborder.component';
import { ChangeNoteMonthFilterDialog } from './dialogs/change-note-month-filter-dialog/change-note-month-filter-dialog';


export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'MMM DD, YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export function appConfigInitializer(configService: ConfigurationService) {
  return () => configService.loadConfiguration();
}


@NgModule({
    declarations: [
        AppComponent,
        NavMenuComponent,
        SummaryPageComponent,
        ProjectsComponent,
        MarketingComponent,
        PmCommercialComponent,
        ScmComponent,
        PlanningComponent,
        StoreComponent,
        LogisticComponent,
        MyTaskComponent,
        EnggDrawComponent,
        EnggProcureComponent,
        PurchasePoComponent,
        PurchaseMaterialReceiptComponent,
        ProductionComponent,
        QualityComponent,
        ReportsComponent,
        SubSalesorderComponent,
        AddSuborderPopup,
        PmTechnicalSuborderComponent,
        ReviewSaveComponent,
        EditSalesOrderComponent,
        SaveConfirmDialog,
        DeleteConfirmDialog,
        LoaderDialog,
        FileUploadDialog,
        SubmitConfirmDialog,
        ActualDateDialog,
        ActualDateDialog2,
        ValidationDialog,
        ProcessFailDialog,
        BrowserFailDialog,
        SOGanttViewerDialog,
        SerialImportDialog,
        MaterialFileUploadComponent,
        ManfPlanComponent,
        MastPlanComponent,
        SubSOUIPipePipe,
        SubEqupUIPipePipe,
        saleOrderPipe,
        MaterialSplitNumberComponent,
        MaterialRevisedDateComponent,
        MyTaskListComponent,
        MyTaskTableComponent,
        ClearInputDirective,
        DownloadsComponent,
        MastPlanV2Component,
        MastPlanV3Component,
        DelMastPlanComponent,
        MaterialColumnFilterComponent,
        ColumnFilterPopComponent,
        DelSubMastPlanComponent,
        ReviewPageComponent,
        KpisComponent,
        // HighchartsChartComponent,
        KpisV2Component,
        KpiExcelComponent,
        GanttSummaryComponent,
        KpisV3Component,
        KpisV4Component,
        KpisV5Component,
        MarketingKpiComponent,
        EnggDrawKpiComponent,
        EnggProcureKpiComponent,
        PmTechnicalSuborderKpiComponent,
        ScmKpiComponent,
        PlanningKpiComponent,
        PurchaseMaterialReceiptKpiComponent,
        StoreKpiComponent,
        ProductionKpiComponent,
        LogisticKpiComponent,
        QualityKpiComponent,
        LineItemImportDialog,
        ChangeNoteComponent,
        SerialDataImportDialog,
        DataPreviewDialog,
        DataSheetComponent,
        AddDatasheetPopup,
        DsGeneralComponent,
        DsPanelComponent,
        DataSheetImportDialog,
        DsBusbarsComponent,
        DsPaintingComponent,
        DsControlAuxComponent,
        DsControlWiringComponent,
        DsTerminalBlocksComponent,
        DsCircuitBreakerComponent,
        DsCurrentTransformerComponent,
        DsPotentialTransformerComponent,
        DsNumericalRelayComponent,
        DsAuxRelayComponent,
        DsMetersComponent,
        DsSurgeArrestorComponent,
        DsAnnuciatorComponent,
        DsSwitchesComponent,
        DsEthSwitchesComponent,
        DsEarthingDevicesComponent,
        DsSpecialDevicesComponent,
        DsFoundationFrameComponent,
        DsSwbAccQtyComponent,
        DsCodesStdsComponent,
        DataSheetSuborderComponent,
        CopyDataSheetSuborderComponent,
        SAPFetchResultDialog,
        ChangeNoteMonthFilterDialog,
        //Ng1GanttwrapperDirective
    ],
    imports: [
        BrowserModule,
        //UpgradeModule,
        HttpClientModule,
        BrowserAnimationsModule,
        FormsModule,
        MatRadioModule,
        ReactiveFormsModule,
        // HttpModule,
        RoutingModule,
        MatDatepickerModule,
        MatProgressBarModule,
        MatCardModule,
        MatChipsModule,
        MatProgressSpinnerModule,
        MatStepperModule,
        MatFormFieldModule,
        MatBottomSheetModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatGridListModule,
        MatDialogModule,
        MatCheckboxModule,
        MatTabsModule,
        MatExpansionModule,
        MatSnackBarModule,
        MatDividerModule,
        MatListModule,
        MatTableModule,
        NoopAnimationsModule,
        MatMomentDateModule,
        MatIconModule,
        MatButtonToggleModule,
        MatSortModule,
        HighchartsChartModule,
        MatTooltipModule
        //ModalModule.forRoot(),
        //SimpleNotificationsModule.forRoot()
    ],
    entryComponents: [ AppComponent, AddSuborderPopup, SaveConfirmDialog,DeleteConfirmDialog,
                     LoaderDialog, FileUploadDialog, ActualDateDialog, SubmitConfirmDialog,
                     ValidationDialog, ProcessFailDialog, BrowserFailDialog, SOGanttViewerDialog,
                     SerialImportDialog, ColumnFilterPopComponent, LineItemImportDialog, SerialDataImportDialog,
                     DataPreviewDialog, AddDatasheetPopup, DataSheetImportDialog, SAPFetchResultDialog,
                     ChangeNoteMonthFilterDialog],
    providers: [GenService, DataService, KPIChartService, CookieService, RevisionHandlerService, ConfigurationService,
      {provide: APP_INITIALIZER, useFactory: appConfigInitializer, deps: [ConfigurationService], multi: true},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { 
  // constructor(upgrade: UpgradeModule) {
    //upgrade.bootstrap(document.documentElement, ['ganttModule']);
  // }
  // ngDoBootstrap(){

  // }
}
